
window.$ = window.jQuery = require('jquery');
require('./web_function')

import 'jquery-ui-dist/jquery-ui';
import 'slick-carousel';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'jquery-validation/dist/localization/messages_zh_TW';

require('./validation/validation_helper')
require('./validation/additional-methods')
require('jsrender');

require('./dialogs/confirm_dialog')
require('./dialogs/loading_dialog')

window.Swal = require('sweetalert2')
